<template>
  <v-container>
    <v-row align="baseline">
      <v-col cols="12" md="6" sm="12" xs="12">
        <v-row align="baseline" justify="end">
          <v-col cols="3" lg="2" md="3" sm="2">
            <v-btn
              variant="text"
              class="mr-3"
              block
              rounded
              size="large"
              @click.stop="router.push({ name: 'home' })"
              :disabled="submitting"
            >
              Cancelar
            </v-btn>
          </v-col>
          <v-col cols="4" lg="2" md="3" sm="2">
            <v-btn
              color="primary"
              block
              rounded
              size="large"
              type="submit"
              :loading="submitting"
              @click="onSubmit"
            >
              Salvar
            </v-btn>
          </v-col>
        </v-row>
      </v-col>
    </v-row>
    <v-form ref="formRef">
      <v-row justify="center">
        <v-col cols="10" lg="7">
          <v-label><b>E-mail</b></v-label>
          <v-text-field
            class="mt-2"
            disabled
            :model-value="authStore.user?.email"
          />
        </v-col>
      </v-row>
      <v-row justify="center">
        <v-col cols="10" lg="7">
          <v-label><b>Senha atual</b></v-label>
          <v-text-field
            class="mt-2"
            v-model="form.oldPassword"
            :rules="[rules.required]"
            :append-inner-icon="showPassword1 ? mdiEye : mdiEyeOff"
            :type="showPassword1 ? 'text' : 'password'"
            @click:append-inner="showPassword1 = !showPassword1"
          />
        </v-col>
      </v-row>
      <v-row justify="center">
        <v-col cols="10" lg="7">
          <v-label><b>Nova senha</b></v-label>
          <v-text-field
            class="mt-2"
            v-model="form.password"
            :rules="[rules.required, rules.password]"
            :append-inner-icon="showPassword2 ? mdiEye : mdiEyeOff"
            :type="showPassword2 ? 'text' : 'password'"
            @click:append-inner="showPassword2 = !showPassword2"
          />
        </v-col>
      </v-row>
      <v-row justify="center">
        <v-col cols="10" lg="7">
          <v-label><b>Confirmar nova senha</b></v-label>
          <v-text-field
            class="mt-2"
            v-model="form.password2"
            :rules="[rules.required, rules.confirmed(form.password)]"
            :append-inner-icon="showPassword3 ? mdiEye : mdiEyeOff"
            :type="showPassword3 ? 'text' : 'password'"
            @click:append-inner="showPassword3 = !showPassword3"
          />
        </v-col>
      </v-row>
    </v-form>
  </v-container>
</template>

<script setup>
import { ref, reactive, computed } from "vue";
import { mdiEye, mdiEyeOff } from "@mdi/js";
import { useRouter } from "vue-router";
import { useAuthStore } from "@/stores/auth";
import { validationRules } from "@/utils/validation";
import { useChangePasswordMutation } from "@/queries/modules/users";
import { useSnackbar } from "@/plugins/snackbar";

const router = useRouter();
const authStore = useAuthStore();
const formRef = ref(null);
const $snackbar = useSnackbar();

const showPassword1 = ref(false);
const showPassword2 = ref(false);
const showPassword3 = ref(false);

const changePasswordMutation = useChangePasswordMutation();
const submitting = computed(() => changePasswordMutation.isPending.value);

const form = reactive({
  oldPassword: "",
  password: "",
  password2: "",
});

const rules = {
  required: validationRules.required,
  password: validationRules.password,
  confirmed: validationRules.confirmed,
};

async function onSubmit() {
  const { valid } = await formRef.value.validate();

  if (valid) {
    try {
      await changePasswordMutation.mutateAsync({
        password: form.password,
        old_password: form.oldPassword,
      });

      // Logout after password change
      authStore.logout();
      router.go();
    } catch (err) {
      $snackbar.error(`Erro ao alterar senha: ${err.message}`);
    }
  }
}
</script>
